import styled from '@emotion/styled'

import { palette, spacing, Strong, Text } from 'main/ui'

interface IProps {
  compact: boolean
}

export const Container = styled.div`
  background-color: ${palette.whiteDove};
  border-radius: 10px;
  display: flex;
  padding: 0 ${spacing.majorScale(4)}px;
`

export const LogoContainer = styled.div<IProps>`
  flex-basis: 0;
  margin-top: ${spacing.majorScale(1)}px;
  margin-left: auto;
  margin-right: ${spacing.minorScale(4)}px;

  // HACK (aboltunov): was having issues making the image stretch properly
  min-width: ${({ compact }) => (compact ? 40 : 25)}px;
`

export const BodyContainer = styled.div<IProps>`
  align-items: ${({ compact }) => (compact ? 'flex-start' : 'flex-end')};
  align-self: center;
  display: flex;
  flex-direction: ${({ compact }) => (compact ? 'column' : 'row')};
  margin-right: auto;
  padding: ${spacing.majorScale(1)}px 0;
`

export const PrimaryStrong = styled(Strong)`
  color: ${palette.fern2};
`

export const SecondaryText = styled(Text)<IProps>`
  color: ${palette.fern2};

  ${({ compact }) => (compact ? null : `margin-left: ${spacing.majorScale(2)}px;`)}
`
